module.exports = __webpack_public_path__ + "img/1-3.7ff53259.png";